export default {"src":"/_next/static/media/icon-stats-attack-range.ab6a1d65.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};